import { render, staticRenderFns } from "./PaymentsToSuppliers.vue?vue&type=template&id=1cd7506a&scoped=true&"
import script from "./PaymentsToSuppliers.vue?vue&type=script&lang=js&"
export * from "./PaymentsToSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd7506a",
  null
  
)

export default component.exports